/* eslint react/no-did-mount-set-state: 0, complexity: 0 */

import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {TESTS, getValue} from '../../../utils/abacus';
import {DynamicQuestions} from '../dynamic-seo-questions/dynamicQuestions';

function mapStateToProps(state) {
    return {
        abacus: state.abacus || {},
        slpText: state.content.slpText,
        destinationName: state.destination.details.simpleName,
        dynamicSeoText: state.destination.dynamicSeoText
    };
}

const slpTextItem = PropTypes.shape({
    content: PropTypes.string,
    seoDescriptionType: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string
});

export class SEOTextComponent extends PureComponent {
    static propTypes = {
        slpText: PropTypes.arrayOf(slpTextItem),
        destinationName: PropTypes.string,
        dynamicSeoText: PropTypes.shape({
            heading: PropTypes.string,
            paragraph: PropTypes.string
        })
    };

    render() {
        const {
            abacus,
            dynamicSeoText,
            slpText = []
        } = this.props;

        // Use the `dynamicSeoText || {}` here instead of destructuring from this.props
        // As `dynamicSeoText` can be `null` sometimes
        const {
            heading,
            paragraph
        } = dynamicSeoText || {};

        const testValue = getValue(abacus, TESTS.SEO_TEXT_REDESIGN);

        let seoText = testValue !== 1 && slpText.length
            ? (<div className="col-md-12">
                {slpText.map(({content, seoDescriptionType, type}) => {
                    /* eslint-disable react/no-danger */
                    return (<div
                        className={`seo-text-type-${type} seo-description-type-${seoDescriptionType.toLowerCase()}`}
                        dangerouslySetInnerHTML={{__html: content}}
                        key={seoDescriptionType}
                    />);
                    /* eslint-enable react/no-danger */
                })}
            </div>)
            : null;

        return (<div className="container module seo-text">
            <div className="content">
                <div className="row">
                    {!heading || !paragraph ? null : (
                        <div className="col-md-12 seo-text-dynamic">
                            <h2>{heading}</h2>
                            <p>{paragraph}</p>
                        </div>
                    )}
                    <DynamicQuestions />
                    {seoText}
                </div>
            </div>
        </div>);
    }
}

export const SEOText = connect(mapStateToProps)(SEOTextComponent);
export default SEOText;
